import React from 'react';
import { Label } from 'react-bootstrap';

const ActiveStatusLabel = (props) => {
    const text = props.isActive ? 'Active' : 'Inactive';
    const labelStyle = props.isActive ? 'success' : 'default';

    return (<Label bsStyle={labelStyle}>{text}</Label>);
};

export default ActiveStatusLabel;



// WEBPACK FOOTER //
// ./src/components/atoms/labels/ActiveStatusLabel.js